/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Rut_S3Inputs */

const en_mk_tut_rut_s3 = /** @type {(inputs: Mk_Tut_Rut_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Say which channel the result posts into, so the team reads it without opening the Routines page.`)
};

const id_mk_tut_rut_s3 = /** @type {(inputs: Mk_Tut_Rut_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentukan ke channel mana hasilnya dikirim, supaya tim membacanya tanpa harus membuka menu Rutinitas.`)
};

/**
* | output |
* | --- |
* | "Say which channel the result posts into, so the team reads it without opening the Routines page." |
*
* @param {Mk_Tut_Rut_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_rut_s3 = /** @type {((inputs?: Mk_Tut_Rut_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Rut_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_rut_s3(inputs)
	return en_mk_tut_rut_s3(inputs)
});